import { EarningEvent } from '@/types/earnings.types';

// Group events by market timing type (Pre Market vs Post Market)
export const groupEventsByType = <T extends EarningEvent>(events: T[]) => {
  const grouped: { [key: string]: T[] } = {};
  events.forEach((event) => {
    // Map API's marketTiming ('pre' or 'post') to display labels
    const key = event.marketTiming === 'post' ? 'Post Market' : 'Pre Market';

    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(event);
  });
  return grouped;
};

// Get dot color based on percentage
export const getDotColor = (percentage: string) => {
  const num = parseInt(percentage.replace('%', ''));
  if (num >= 80) return '#10b981'; // green
  if (num >= 50) return '#e8b046'; // yellow
  return '#e0664f'; // red
};
